import React from 'react'
import { useField } from 'formik'
import Textarea, { IProps } from '../Textarea'

const FormikTextarea = (
  props: Omit<IProps, 'errorMessage' | 'onChange' | 'value' | 'meta'> & {
    name: string
  }
) => {
  const [field, meta] = useField(props)

  return <Textarea {...props} {...field} meta={meta} />
}

export default FormikTextarea
